<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tp01"><a id="page03">
<h2 class="titlePageTitle"><span class="bold"><span>5 Bodies to Die For</span></span></h2>
<h2 class="titlePageAuthor2"><span class="bold"><span>A Body Movers Novel</span></span></h2>
<h2 class="titlePageAuthor"><span class="bold"><span>Stephanie Bond</span></span></h2>
<p class="image"><span><img alt="image" src="Images/logo.jpg"/></span></p></a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5bodiestodiefor_tp01.vue?9fce2448